import { Component, ElementRef, HostListener, inject, Input } from '@angular/core';
import { Profile } from '@projects/adir/src/interfaces/profile.interface';
import { AvatarComponent } from '@shared/src/lib/components/avatar/avatar.component';
import { ChevronDownIconComponent } from '@shared/src/lib/icons/chevron-down-icon/chevron-down-icon.component';
import { UserPanelComponent } from '@shared/src/lib/components/user-panel/user-panel.component';
import { UserPanel } from '@shared/src/lib/components/user-panel/user-panel.interface';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '@shared/src/services/auth/auth.service';
import { DefaultProfileIconComponent } from '@shared/src/lib/icons/default-profile-icon/default-profile-icon.component';

@Component({
  selector: 'lib-profile',
  standalone: true,
  imports: [AvatarComponent, ChevronDownIconComponent, UserPanelComponent, DefaultProfileIconComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent {
  @Input() profile: Profile.Response;
  user = inject(AuthService).currentUser();
  showOptions = false;
  menuItems: UserPanel[] = [{ name: 'Log Out', iconName: 'logout', action: () => this.logout() }];

  constructor(
    private readonly msalService: MsalService,
    private readonly authService: AuthService,
    private readonly eRef: ElementRef
  ) {}

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showOptions = false;
    }
  }
  toggleOptions() {
    this.showOptions = !this.showOptions;
  }

  logout() {
    this.authService.clearSession().subscribe({
      next: () => {
        localStorage.clear();
        this.msalService.logout();
      },
    });
  }
}
